PJQ.views.resources = {};

PJQ.constants.resources = {
    allocationManagerGroupBy: {
        PROJECT_MANAGER_PROJECT: 1,
        PROJECT_MANAGER_RESOURCE: 2,
        RESOURCE_PROJECT_MANAGER: 3
    },
    projectFilter: {
        ALL_PROJECTS: -1,
        MY_PROJECTS: -2
    },
    filterType: {
        PROJECT_FILTER: 'projectFilter',
        PROJECT_STATUS_FILTER: 'projectStatusFilter'
    },
    scheduleWidthDay: 1.19047619047619,
    colors: {
        default: '2196F3',
        warning: 'FF0000',
        other: '7a0101'
    },
    resourceIdUnassignedProjects: -2
};

PJQ.helpers.resources = {
    getResourceScheduleStartEndColumn: function(project, resource, startDate) {
        let result = '', eventStartDate = null, eventEndDate = null, projectResource = ((project && resource) ? project.getProjectResource(resource.id) : resource), offsetLeft = 0, width = 0;

        if (projectResource && projectResource.startDate)
            eventStartDate = PJQ.helpers.dateHelpers.parseDateString(projectResource.startDate, false);
        else if (project.get('startDate'))
            eventStartDate = PJQ.helpers.dateHelpers.parseDateString(project.get('startDate'), false);

        if (projectResource && projectResource.endDate)
            eventEndDate = PJQ.helpers.dateHelpers.parseDateString(projectResource.endDate, false);
        else if (project.get('endDate'))
            eventEndDate = PJQ.helpers.dateHelpers.parseDateString(project.get('endDate'), false);

        if (eventStartDate && eventEndDate) {
            if (eventStartDate <= startDate)
                offsetLeft = 0;
            else
                offsetLeft = PJQ.helpers.dateHelpers.getTimeStats(eventStartDate, startDate).totalDays * PJQ.constants.resources.scheduleWidthDay;

            if (eventEndDate > startDate.addDays(7 * 12))
                width = 100 - offsetLeft;
            else
                width = (PJQ.helpers.dateHelpers.getTimeStats(eventEndDate, eventStartDate < startDate ? startDate : eventStartDate).totalDays + 1) * PJQ.constants.resources.scheduleWidthDay;
        }

        return { offsetLeft: offsetLeft, width: width };
    }
};

if (PJQ.app.module === PJQ.constants.modules.RESOURCES) {
    PJQ.app.addOldRoutes([
        {
            route: '',
            name: 'default',
            callback: function () {
                PJQ.app.router.navigate('resources', {
                    trigger: true,
                    replace: true
                });
            }
        }
    ]);
}

PJQ.modules.resources = {
    routes: [
        {
            route: 'resources',
            name: 'resources',
            callback: function () {
                PJQ.app.session.project = null;
                if (PJQ.app.module === PJQ.constants.modules.APP) {
                    if (PJQ.app.session.get('ownsPortal')) {
                        PJQ.app.initNavigator({
                            activeItem: "resources"
                        });
                    }
                    else {
                        PJQ.app.initNavigator();
                    }
                }
                else {
                    PJQ.app.view.renderView(PJQ.views.resources.ResourceAllocation);
                }
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.resources.routes);